import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
} from '@chakra-ui/react';

import { CrossOutline } from '@aslanpay/portal-common-lib';

interface ReferralCodeFieldProps {
  value: string;
  error: string;
  isValidating: boolean;
  onChange: (value: string) => void;
}

/** Optional referral-code input shown to employees on the passcode step (CVC-CVC-CVC). */
function ReferralCodeField({ value, error, isValidating, onChange }: ReferralCodeFieldProps) {
  return (
    <FormControl isInvalid={!!error}>
      <FormLabel>Referral code (optional)</FormLabel>
      <InputGroup>
        <Input
          data-testid="referral-code-input"
          placeholder="ABC-DEF-GHI"
          autoCapitalize="characters"
          value={value}
          onChange={(event) => onChange(event.currentTarget.value)}
        />
        {(isValidating || value) && (
          <InputRightElement h="full">
            {isValidating ? (
              <Spinner size="sm" color="brand.purple" />
            ) : (
              <IconButton
                data-testid="clear-referral-code"
                aria-label="Clear referral code"
                icon={<CrossOutline color="brand.darkGray" boxSize="24px" />}
                variant="ghost"
                size="sm"
                onClick={() => onChange('')}
              />
            )}
          </InputRightElement>
        )}
      </InputGroup>
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
}

export default ReferralCodeField;
